<template>
  <v-data-table
    :headers="engineerStockDataTableHeaders"
    :items="engineerStockList"
    class="elevation-1"
    :loading="isLoadingEngineerStock"
    :loading-text="$t('common_get_data')"
    :no-data-text="$t('common_no_data')"
    :no-results-text="$t('common_no_results')"
    :footer-props="{
      'items-per-page-options': [30, 50, 100],
      'items-per-page-text': $t('item_rows_per_page'),
    }"
    :header-props="headerProps"
    :search="search"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>{{ $t('engineer_stock_title') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          :label="$t('point_search_label')"
          single-line
          hide-details
          clearable
        ></v-text-field>
        <v-dialog v-model="isShowEditEngineerStockDialog" fullscreen persistent>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              class="mb-2 ml-8"
              v-bind="attrs"
              v-on="on"
              :disabled="isAllTextFieldDisable"
            >
              {{ $t('common_new') }}
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ title }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <ValidationObserver ref="dialogEngineerStock">
                  <v-row>
                    <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                      <ValidationProvider
                        :name="$t('engineer_stock_user')"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-autocomplete
                          v-model="editedEngineerStock.UserName"
                          :items="userList"
                          item-text="NickName"
                          item-value="UserName"
                          required
                          :loading-text="$t('common_get_data')"
                          :no-data-text="$t('common_no_results')"
                          :error-messages="errors[0]"
                          @keyup.enter="setUserNameAutocomplete"
                          ref="userNameAutocomplete"
                        >
                          <template v-slot:label>
                            <span class="red--text">
                              <strong>* </strong>
                            </span>
                            {{ $t('engineer_stock_user') }}
                          </template>
                        </v-autocomplete>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                      <ValidationProvider
                        :name="$t('engineer_stock_stock_number')"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-autocomplete
                          v-model="editedEngineerStock.StockNumber"
                          :items="stockList"
                          item-text="Mc002"
                          item-value="Mc001"
                          required
                          :loading-text="$t('common_get_data')"
                          :no-data-text="$t('common_no_results')"
                          :error-messages="errors[0]"
                          @change="getStockItem"
                          @keyup.enter="setStockNumberAutocomplete"
                          ref="stockNumberAutocomplete"
                        >
                          <template v-slot:label>
                            <span class="red--text">
                              <strong>* </strong>
                            </span>
                            {{ $t('engineer_stock_stock_number') }}
                          </template>
                        </v-autocomplete>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </ValidationObserver>
              </v-container>
            </v-card-text>
            <v-data-table
              :headers="stockItemDataTableHeaders"
              :items="editedEngineerStock.StockItems"
              class="elevation-1 ma-5"
              :loading-text="$t('common_get_data')"
              :no-data-text="$t('common_no_data')"
              :no-results-text="$t('common_no_results')"
              :footer-props="{
                'items-per-page-options': [30, 50, 100],
                'items-per-page-text': $t('item_rows_per_page'),
              }"
              :header-props="headerProps"
              :search="searchItem"
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title>{{ $t('stock_item_title') }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="searchItem"
                    append-icon="mdi-magnify"
                    :label="$t('point_search_label')"
                    single-line
                    hide-details
                    clearable
                  ></v-text-field>
                  <v-dialog v-model="isShowEditStockItemDialog" max-width="800px" persistent>
                    <v-card>
                      <v-card-title>
                        <span class="text-h5">{{ $t('common_edit') }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container>
                          <ValidationObserver ref="dialogStockItem">
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                                <ValidationProvider
                                  :name="$t('item_number')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedStockItem.ItemNumber"
                                    :label="$t('item_number')"
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('item_number') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                                <ValidationProvider
                                  :name="$t('item_name')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedStockItem.ItemName"
                                    :label="$t('item_name')"
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('item_name') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                                <ValidationProvider
                                  :name="$t('stock_item_quantity')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedStockItem.StockQuantity"
                                    :label="$t('stock_item_quantity')"
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('stock_item_quantity') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                                <ValidationProvider
                                  :name="$t('stock_item_safe_quantity')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedStockItem.SafeQuantity"
                                    :label="$t('stock_item_safe_quantity')"
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('stock_item_safe_quantity') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                          </ValidationObserver>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click="closeStockItem">
                          {{ $t('common_cancel') }}
                        </v-btn>
                        <v-btn color="green darken-1" text @click="addStockItem">
                          {{ $t('common_confirm') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>
              <template v-slot:[`item.Edit`]="{ item }">
                <v-btn icon @click="isShowEditedStockItemBtn(item)">
                  <v-icon small>
                    mdi-pencil
                  </v-icon>
                </v-btn>
              </template>
            </v-data-table>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="red darken-1"
                text
                @click="closeEditedEngineerStock"
                :disabled="isAllTextFieldDisable"
              >
                {{ $t('common_cancel') }}
              </v-btn>
              <v-btn
                color="green darken-1"
                text
                @click="saveEditedEngineerStock"
                :loading="isLoadingSaveBtn"
              >
                {{ $t('common_save') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <delete-dialog
          :isAllTextFieldDisable="isAllTextFieldDisable"
          :isLoadingSaveBtn="isLoadingDeleteBtn"
          :isShowDeleteDialog="isShowDeleteEngineerStockDialog"
          :deleteMessage="'engineer_stock_message'"
          @closeDelete="closeDeleteEngineerStock"
          @confirmDelete="confirmDeleteEngineerStock"
        />
      </v-toolbar>
    </template>
    <template v-slot:[`item.Edit`]="{ item }">
      <v-btn icon @click="isShowEditedEngineerStockBtn(item)">
        <v-icon small>
          mdi-pencil
        </v-icon>
      </v-btn>
      <v-btn icon @click="isShowDeleteEngineerStockBtn(item)">
        <v-icon small>
          mdi-delete
        </v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { HttpEngineerStock, HttpUser, HttpCmsmc } from '@/js/http-Manager'
import DeleteDialog from '@/components/DeleteDialog.vue'

export default {
  name: 'EngineerStock',
  components: { DeleteDialog },
  data: () => ({
    isShowEditEngineerStockDialog: false,
    userList: [],
    stockList: [],
    editedEngineerStockIndex: -1,
    search: '',
    editedEngineerStock: {
      Id: '',
      UserName: '',
      Ma001: ''
    },
    defaultEngineerStock: {
      Id: '',
      UserName: '',
      Ma001: ''
    },
    isLoadingEngineerStock: true,
    isLoadingSaveBtn: false,
    isAllTextFieldDisable: false,
    isShowDeleteEngineerStockDialog: false,
    isLoadingDeleteBtn: false,
    isDeleteBtnDisable: false,
    engineerStockList: [],
    searchItem: '',
    isShowEditStockItemDialog: false,
    editedStockItem: {
      ItemId: '',
      ItemNumber: '',
      ItemName: '',
      StockQuantity: 0,
      SafeQuantity: 0
    },
    defaultStockItem: {
      ItemId: '',
      ItemNumber: '',
      ItemName: '',
      StockQuantity: 0,
      SafeQuantity: 0
    },
    editedStockItemIndex: -1
  }),
  async mounted () {
    await this.getEngineerStock()
    await this.getEngineerUser()
    await this.getStock()
  },
  computed: {
    engineerStockDataTableHeaders () {
      return [
        { text: this.$t('installation_notice_engineer'), align: 'start', value: 'NickName' },
        { text: this.$t('engineer_stock_number'), align: 'start', value: 'StockNumber' },
        {
          text: this.$t('engineer_stock_name'),
          align: 'start',
          value: 'StockName'
        },
        {
          text: this.$t('common_edit'),
          align: 'center',
          value: 'Edit',
          sortable: false
        }
      ]
    },
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    },
    stockItemDataTableHeaders () {
      return [
        { text: this.$t('item_number'), align: 'start', value: 'ItemNumber' },
        { text: this.$t('item_name'), align: 'start', value: 'ItemName' },
        {
          text: this.$t('stock_item_quantity'),
          align: 'end',
          value: 'StockQuantity'
        },
        {
          text: this.$t('stock_item_safe_quantity'),
          align: 'end',
          value: 'SafeQuantity'
        },
        {
          text: this.$t('common_edit'),
          align: 'center',
          value: 'Edit',
          sortable: false
        }
      ]
    },
    title () {
      return this.editedEngineerStockIndex === -1 ? this.$t('common_new') : this.$t('common_edit')
    }
  },
  methods: {
    setUserNameAutocomplete (event) {
      this.$refs.userNameAutocomplete.isMenuActive = false
      this.$refs.userNameAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setStockNumberAutocomplete (event) {
      this.$refs.stockNumberAutocomplete.isMenuActive = false
      this.$refs.stockNumberAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (
          form[i].type !== 'hidden' &&
          !form[i].disabled &&
          !form[i].readOnly &&
          form[i].type !== 'checkbox'
        ) {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },
    async getStockItem () {
      let response = await HttpEngineerStock.GetStockItem({
        stockNumber: this.editedEngineerStock.StockNumber
      })
      this.editedEngineerStock.StockItems = response.status === 200 ? response.data.Data : []
      this.editedEngineerStock = JSON.parse(JSON.stringify(this.editedEngineerStock))
    },
    async getStock () {
      let response = await HttpCmsmc.GetStock()
      this.stockList = response.status === 200 ? response.data.Data : []
    },
    async getEngineerStock () {
      this.isLoadingEngineerStock = true
      let response = await HttpEngineerStock.GetEngineerStock()
      this.isLoadingEngineerStock = false
      this.engineerStockList = response.status === 200 ? response.data.Data : []
    },
    async getEngineerUser () {
      let response = await HttpUser.GetEngineerUser()
      this.userList = response.status === 200 ? response.data.Data : []
    },
    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return '-'
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    },
    isShowEditedEngineerStockBtn (item) {
      this.editedEngineerStockIndex = this.engineerStockList.indexOf(item)
      let str = JSON.stringify(item)
      this.editedEngineerStock = JSON.parse(str)
      this.isShowEditEngineerStockDialog = true
    },
    closeEditedEngineerStock () {
      this.isShowEditEngineerStockDialog = false
      this.isLoadingSaveBtn = false
      this.isAllTextFieldDisable = false

      this.$nextTick(() => {
        this.editedEngineerStock = JSON.parse(JSON.stringify(this.defaultEngineerStock))
        this.editedEngineerStockIndex = -1
      })
    },

    async saveEditedEngineerStock () {
      const isValid = await this.$refs.dialogEngineerStock.validate()
      if (isValid) {
        this.isLoadingSaveBtn = true
        this.isAllTextFieldDisable = true
        this.isLoadingEngineerStock = true
        if (this.editedEngineerStockIndex === -1) {
          await HttpEngineerStock.AddEngineerStock(this.editedEngineerStock)
        } else {
          await HttpEngineerStock.UpdateEngineerStock(this.editedEngineerStock)
        }

        await this.getEngineerStock()
        this.closeEditedEngineerStock()
      }
    },
    isShowDeleteEngineerStockBtn (item) {
      this.editedEngineerStockIndex = this.engineerStockList.indexOf(item)
      let str = JSON.stringify(item)
      this.editedEngineerStock = JSON.parse(str)
      this.isShowDeleteEngineerStockDialog = true
    },
    async confirmDeleteEngineerStock () {
      this.isLoadingDeleteBtn = true
      this.isDeleteBtnDisable = true
      this.isLoadingEngineerStock = true
      await HttpEngineerStock.UpdateEngineerStockIsDelete(
        this.engineerStockList[this.editedEngineerStockIndex].Id
      )
      this.isLoadingDeleteBtn = false
      this.isDeleteBtnDisable = false
      this.isLoadingEngineerStock = false
      await this.getEngineerStock()
      this.closeDeleteEngineerStock()
    },

    closeDeleteEngineerStock () {
      this.isShowDeleteEngineerStockDialog = false
      this.$nextTick(() => {
        let str = JSON.stringify(this.defaultEngineerStock)
        this.editedEngineerStock = JSON.parse(str)
        this.editedEngineerStockIndex = -1
      })
    },
    isShowEditedStockItemBtn (item) {
      this.editedStockItemIndex = this.editedEngineerStock.StockItems.indexOf(item)
      let str = JSON.stringify(item)
      this.editedStockItem = JSON.parse(str)
      this.isShowEditStockItemDialog = true
    },
    closeStockItem () {
      this.isShowEditStockItemDialog = false
      this.$nextTick(() => {
        let str = JSON.stringify(this.defaultStockItem)
        this.editedStockItem = JSON.parse(str)
        this.editedStockItemIndex = -1
      })
    },
    async addStockItem () {
      const isValid = await this.$refs.dialogStockItem.validate()
      if (isValid) {
        this.editedEngineerStock.StockItems.splice(
          this.editedStockItemIndex,
          1,
          this.editedStockItem
        )
        this.closeStockItem()
      }
    }
  }
}
</script>
